var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImgPicker = function SvgImgPicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4D55",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.808 18.5h14.384c.723 0 1.308-.585 1.308-1.308V2.808c0-.723-.585-1.308-1.308-1.308H2.808c-.723 0-1.308.585-1.308 1.308v14.384c0 .723.585 1.308 1.308 1.308"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4D55",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m3.134 18.5 9.546-8.997a.654.654 0 0 1 .837 0l4.983 3.57M6.73 8.692a1.962 1.962 0 1 0 0-3.923 1.962 1.962 0 0 0 0 3.923"
  })));
};
export default SvgImgPicker;